import {useQuery} from '@tanstack/react-query';

import {getEventTemplates} from '../api';
import {QUERY__EVENT_TEMPLATES} from '../queryKeys';

export const useGetEventTemplates = () => {
  return useQuery({
    queryKey: [QUERY__EVENT_TEMPLATES],
    queryFn: () => getEventTemplates(),
  });
};
